'use strict';

const React = require('react');

const PropTypes = require('prop-types');

const { MediaQuery, queries } = require('dibs-media-query');
const GalleryPhotoContainer = require('./GalleryPhotoContainer');
const GalleryPhotoImage = require('./GalleryPhotoImage');
const GalleryPhotoItemTags = require('./GalleryPhotoItemTags');
const GalleryPhotoSocial = require('./GalleryPhotoSocial');
const GalleryPhotoPagination = require('./GalleryPhotoPagination');

function GalleryPhotoWrapper(props) {
    const { photoData, handlers, allowTouchEvents, updateImageDimensions } = props;

    return (
        <GalleryPhotoContainer
            {...handlers}
            allowTouchEvents={allowTouchEvents}
            photoData={photoData}
        >
            {/* Image */}
            <GalleryPhotoImage
                photoId={photoData.photoId}
                photoSrc={photoData.photoSrc}
                photoAlt={photoData.photoAlt}
                updateImageDimensions={updateImageDimensions}
            />

            {/* Photo Item Tags (only on desktop) */}
            {!allowTouchEvents && photoData.itemTags.length ? (
                <MediaQuery query={[queries.lg, queries.xl]}>
                    <GalleryPhotoItemTags
                        key={photoData.photoId}
                        itemTags={photoData.itemTags}
                        itemTagsState={props.itemTagsState}
                        creatorsMap={photoData.creatorsMap}
                        categoriesMap={photoData.categoriesMap}
                        imageDimensions={photoData.imageDimensions}
                        similarItemsUrls={photoData.similarItemsUrls}
                        showItemTagTooltip={props.showItemTagTooltip}
                        hideItemTagTooltip={props.hideItemTagTooltip}
                        showItemTagIndicators={props.showItemTagIndicators}
                        hideItemTagIndicators={props.hideItemTagIndicators}
                        trackLinkClick={props.trackLinkClick}
                    />
                </MediaQuery>
            ) : null}

            {/* Social (only on desktop) */}
            <MediaQuery query={[queries.lg, queries.xl]}>
                <GalleryPhotoSocial sharePhoto={props.sharePhoto} />
            </MediaQuery>

            {/* Pagination */}
            <GalleryPhotoPagination
                photoIndex={photoData.photoIndex}
                totalPhotos={photoData.totalPhotos}
            />
        </GalleryPhotoContainer>
    );
}

GalleryPhotoWrapper.propTypes = {
    photoData: PropTypes.shape({
        itemTags: PropTypes.array.isRequired,
        photoId: PropTypes.number.isRequired,
        photoSrc: PropTypes.string.isRequired,
        photoAlt: PropTypes.string.isRequired,
        photoIndex: PropTypes.number.isRequired,
        totalPhotos: PropTypes.number.isRequired,

        creatorsMap: PropTypes.object.isRequired,
        categoriesMap: PropTypes.object.isRequired,
        imageDimensions: PropTypes.shape({
            width: PropTypes.number.isRequired,
            height: PropTypes.number.isRequired,
        }).isRequired,
        similarItemsUrls: PropTypes.object,
    }).isRequired,
    itemTagsState: PropTypes.shape({
        activeItemTag: PropTypes.number,
        showItemTags: PropTypes.bool.isRequired,
    }).isRequired,
    allowTouchEvents: PropTypes.bool.isRequired,

    // Actions
    handlers: PropTypes.shape({
        next: PropTypes.func.isRequired,
        prev: PropTypes.func.isRequired,
        zoomIn: PropTypes.func.isRequired,
    }).isRequired,
    updateImageDimensions: PropTypes.func.isRequired,
    showItemTagIndicators: PropTypes.func.isRequired,
    hideItemTagIndicators: PropTypes.func.isRequired,
    showItemTagTooltip: PropTypes.func.isRequired,
    hideItemTagTooltip: PropTypes.func.isRequired,
    trackLinkClick: PropTypes.func.isRequired,
    sharePhoto: PropTypes.func.isRequired,
};

module.exports = GalleryPhotoWrapper;



// WEBPACK FOOTER //
// ./assets/js/gallery/components/GalleryPhotoWrapper.jsx